import { PropsWithChildren } from 'react';

import { Form, FormSubmit } from 'libs/form';

export interface DirectoryRecordFormProps {
  initialValues?: any;
  validationSchema?: any;
  onSubmit: FormSubmit<any>;
  initialReadOnly?: boolean;
}

export const DirectoryRecordForm = ({
  initialValues,
  validationSchema,
  onSubmit,
  children,
  initialReadOnly,
}: PropsWithChildren<DirectoryRecordFormProps>) => (
  <Form
    initialShowCopyButton
    initialReadOnly={initialReadOnly}
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {children}
  </Form>
);
